



























































































import Vue from "vue";
import Page from "@/components/Page.vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import IconButton from "@/components/IconButton.vue";
import eventBus from "@/services/eventBus";

import store, {PartnerPayDateStore} from "../services/PartnerPayDateStore";

interface Data {
    loading: boolean;
    store: PartnerPayDateStore;
    eventBus: any;
}

interface Methods {
    create(): void;
    edit(id: number): void;
    remove(id: number): void;
    getPayCountTypeName(countType: number): string;
    getPayModeName(payMode: number): string;
    getPayDayTypeName(payDay: number): string;
}

interface Computed {
    columns: ApiSearchColumn[];
    url: string;
}

export default Vue.extend<Data, Methods, Computed, {}>({
    components: {
        ApiSearchPage,
        Page,
        IconButton
    },

    async beforeMount() {
        this.loading = true;
        await store.loadPayCountTypes();
        await store.loadPayModes();
        await store.loadPayDayTypes();
        this.loading = false;
    },

    data() {
        return {
            loading: false,
            eventBus,
            store
        };
    },

    methods: {
        create(): void {
            this.$router.push('/partner-paydate/paydate/create');
        },
        edit(id: number): void {
            this.$router.push(`/partner-paydate/paydate/edit/${id}`);
        },
        remove(id: number): void {
            store.removePartnerPayDate(id).then(r => eventBus.$emit('refreshPartnerPayDays'));
        },
        getPayCountTypeName(payCountType: number): string {
            return store.payCountTypes.find((x) => x.id == payCountType)?.name ?? "";
        },
        getPayModeName(payMode: number): string {
            return store.payModes.find((x) => x.id == payMode)?.name ?? "";
        },
        getPayDayTypeName(payDay: number): string {
            return store.payDayTypes.find((x) => x.id == payDay)?.name ?? "";
        },
    },

    computed: {
        url() {
            return `partner-paydate/paydates/search`;
        },
        columns: function() {
            return [
                {
                    field: "id",
                    title: "",
                    cell: 'command',
                    headerClass: "detailsColumn",
                    filterable: false,
                    sortable: false
                },
                {
                    field: "id",
                    title: "ID",  
                    filterable: false, 
                    sortable: false ,
                    type: ColumnType.Right
                },
                {
                    field: "name",
                    title: "Név"
                },
                {
                    field: "note",
                    title: "Leírás"
                },
                { //TODO: Multiselect?
                    field: "isCustomer",
                    title: "Vevői",
                    cell: "isCustomer",
                    type: ColumnType.Center
                },
                { //TODO: Multiselect?
                    field: "isSupplier",
                    title: "Szállítói",
                    cell: "isSupplier",
                    type: ColumnType.Center
                },
                {
                    title: "Fizetési mód",
                    field: "paymentMode",
                    cell: "paymentMode",
                    multiselect: true,
                    multiselectField: "selectedPayModes",
                    multiselectOptions: store.payModes.map((x) => ({
                        text: x.name,
                        value: x.id,
                    })),
                },
                { 
                    field: "startDate",
                    title: "Érvényesség kezdete",
                    type: ColumnType.Date
                },
                {
                    field: "countType",
                    title: "Honnan kell számolni",
                    cell: "countType",
                    multiselect: true,
                    multiselectField: "selectedPayCountTypes",
                    multiselectOptions: store.payCountTypes.map((x) => ({
                        text: x.name,
                        value: x.id,
                    })),
                },
                {
                    field: "payTerm",
                    title: "Fizetési határidő",
                    type: ColumnType.Right
                },
                { 
                    field: "dayType",
                    title: "Milyen napokra vonatkozik",
                    cell: "dayType",
                    multiselect: true,
                    multiselectField: "selectedPayDayTypes",
                    multiselectOptions: store.payDayTypes.map((x) => ({
                        text: x.name,
                        value: x.id,
                    }))
                },
                {
                    field: "day",
                    title: "Hanyadik nap",
                    type: ColumnType.Right
                },
                {
                    field: "customerAccCode",
                    title: "Vevői skontó főkönyvi szám",
                    type: ColumnType.Right
                },
                {
                    field: "supplierlAccCode",
                    title: "Szállítói skontó főkönyvi szám",
                    type: ColumnType.Right
                },
                {
                    field: "skontoDays",
                    title: "Skontó napok száma",
                    type: ColumnType.Right
                },
                {
                    field: "skontoPercent",
                    title: "Skontó %",
                    type: ColumnType.Right
                },
            ];
        },
    },
});
